module.exports = __webpack_public_path__ + "681cc0c91c28e26d58e7f53fe6a91755.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/infection_rate.png
 ** module id = 286
 ** module chunks = 0
 **/